export const navigatorConstants = [
  { url: 'timer', label: 'Timer' },
  { url: 'minimal', label: 'Minimal Timer' },
  { url: 'clock', label: 'Wall Clock' },
  { url: 'backstage', label: 'Backstage' },
  { url: 'timeline', label: 'Timeline (beta)' },
  { url: 'public', label: 'Public' },
  { url: 'lower', label: 'Lower Thirds' },
  { url: 'studio', label: 'Studio Clock' },
  { url: 'countdown', label: 'Countdown' },
  { url: 'info', label: 'Project Info' },
];

// default time format to use for users in 12 hour clocks
export const FORMAT_12 = 'h:mm:ss a';
// default time format to use for users in 24 hour clocks
export const FORMAT_24 = 'HH:mm:ss';
